import { Id, toast, Slide, TypeOptions } from "react-toastify";

/**
 * function that renders toast message to be shown in the toast container
 * @returns Toast id
 */
export const Toast = (message: string, type: string): Id => {
    let typeOption: TypeOptions;
    switch(type){
      case "success": 
        typeOption = toast.TYPE.SUCCESS
        break;
      case "warning": 
        typeOption = toast.TYPE.WARNING
        break;
      case "error": 
        typeOption = toast.TYPE.ERROR
        break;
      case "notice": 
        typeOption = toast.TYPE.INFO
        break;
      default:
        typeOption = toast.TYPE.DEFAULT
    }
    
    return toast(message, {
      position: "top-center",
      autoClose: 9000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      type: typeOption,
      theme: "colored",
      transition: Slide,
      className: "toast-message",
    });
};
